import {useTranslations} from 'next-intl';
import Link from 'next/link';
import {ExperiencesCard} from '../basics/ExperiencesCard';
import {AudiosIcon} from '../svg/AudiosIcon';
import {ExercisesIcon} from '../svg/ExercisesIcon';
import {ArtGalleryIcon} from '../svg/ArtGalleryIcon';
import {ArticlesIcon} from '../svg/ArticlesIcon';

export const ExperiencesNavigation = () => {
  const t = useTranslations('Experiences');

  const experiences = [
    {
      href: '/experiences/audios',
      icon: <AudiosIcon />,
      subheader: t('audiosSubheader'),
      title: t('audiosTitle'),
      description: t('audiosDescription'),
      btnText: t('audiosButtonText'),
      extraClasses: 'hover:bg-[#f8e8f0]',
    },
    {
      href: '/experiences/exercises',
      icon: <ExercisesIcon />,
      subheader: t('exercisesSubheader'),
      title: t('exercisesTitle'),
      description: t('exercisesDescription'),
      btnText: t('exercisesButtonText'),
      extraClasses: 'hover:bg-[#f1e9fd]',
    },
    {
      href: '/gallery',
      icon: <ArtGalleryIcon />,
      subheader: t('artSubheader'),
      title: t('artTitle'),
      description: t('artDescription'),
      btnText: t('artButtonText'),
      extraClasses: 'hover:bg-[#f6fee1]',
    },
    {
      href: '/blog',
      icon: <ArticlesIcon />,
      subheader: t('articlesSubheader'),
      title: t('articlesTitle'),
      description: t('articlesDescription'),
      btnText: t('articlesButtonText'),
      extraClasses: 'hover:bg-[#fff3d8]',
    },
  ];

  return (
    <section className="p-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 md:mb-16 max-w-4xl">
          <h1 className="text-4xl md:text-4xl font-montserrat font-bold mb-4">
            {t('title')}
          </h1>
          <h2 className="text-2xl md:text-3xl mb-6">{t('subtitle')}</h2>
          <p className="text-lg leading-relaxed">- {t('description')}</p>
        </div>

        <div className="grid lg:grid-cols-4 gap-4">
          {experiences.map(exp => (
            <div key={exp.title} className="col-span-1">
              <Link href={exp.href} className="cursor-pointer">
                <ExperiencesCard
                  icon={exp.icon}
                  href={exp.href}
                  subheader={exp.subheader}
                  title={exp.title}
                  description={exp.description}
                  btnText={exp.btnText}
                  extraClasses={exp.extraClasses}
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
